import { render, staticRenderFns } from "./excavate.vue?vue&type=template&id=fee21874"
import script from "./excavate.vue?vue&type=script&lang=js"
export * from "./excavate.vue?vue&type=script&lang=js"
import style0 from "./excavate.vue?vue&type=style&index=0&id=fee21874&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports